import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className='w-10/12 m-auto bg-indigo-200 my-8 h-auto py-12'>
        <div className='order w-10/12 md:w-4/12 m-auto  rounded-lg bg-white'>
          <img src='illustration-hero.svg' className='rounded-t-lg'></img>
          <div className='write-up flex flex-col gap-y-4 my-8'>
          <div className='text-slate-800 text-xl  md:text-2xl font-bold'>
            Order Summary
          </div>
          <div className='text-xs md:text-sm w-9/12 md:w-8/12 m-auto pb-4 text-gray-500'>
          You can now listen to millions of songs audiobooks, and podcasts on any device anywhere you like!

          </div>
          <div className='annual flex flex-row w-10/12 m-auto rounded-lg bg-indigo-50 my-4 py-4 justify-around'>
            <div className='flex flex-row w-8/12 md:w-6/12 justify-evenly'>
            <div className=' w-10 h-10 md:w-12 md:h-12 flex justify-center items-center rounded-full bg-indigo-100 '>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor " className=" w-6 h-6 text-slate-500">
  <path fillRule="evenodd" d="M19.952 1.651a.75.75 0 01.298.599V16.303a3 3 0 01-2.176 2.884l-1.32.377a2.553 2.553 0 11-1.403-4.909l2.311-.66a1.5 1.5 0 001.088-1.442V6.994l-9 2.572v9.737a3 3 0 01-2.176 2.884l-1.32.377a2.553 2.553 0 11-1.402-4.909l2.31-.66a1.5 1.5 0 001.088-1.442V9.017 5.25a.75.75 0 01.544-.721l10.5-3a.75.75 0 01.658.122z" clipRule="evenodd" />
</svg>


            </div>
            <div className='flex flex-col'>
              <p className='font-bold md:text-base text-sm'>Annual Plan</p>
              <p className='text-gray-400 md:text-base text-sm'>$5.99/year</p>
            </div>

            </div>
            <div className='underline text-violet-700 font-bold flex items-center md:text-sm text-xs'>
              Change
            </div>
          </div>

          <button className='annual h-12 flex flex-row w-10/12 m-auto justify-center items-center rounded-lg bg-indigo-600 mt-4 py-4 text-xs md:text-sm font-medium text-white shadow-2xl'>
            Proceed to Payment</button>
            <button className='annual h-12 flex flex-row w-10/12 m-auto justify-center text-xs md:text-sm font-bold text-gray-400'>
            Cancel Order</button>
          

          </div>

        </div>

      </div>

    </div>
  );
}

export default App;
